import Reveal from '@/components/feature/Reveal';

const POINTS = [
  {
    icon: 'ri-error-warning-line',
    title: 'Leverage magnifies both wins and losses',
    body: 'Trading leveraged gold (XAUUSD) carries a high level of risk and can result in the loss of all of your invested capital. Never trade with money you cannot afford to lose.',
  },
  {
    icon: 'ri-history-line',
    title: 'Past performance is not a prediction',
    body: 'The results on this page come from one live account over a limited period. They are not indicative of future results — a different market regime can produce very different outcomes.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'How these figures are produced',
    body: 'Every number is derived from the account\u2019s own closed-trade log and includes swap. Broker commission is charged separately and is not shown; the record has not been independently audited.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Not investment advice',
    body: 'This page is provided for information only and is not a recommendation to buy, sell or hold any instrument. Seek advice from a licensed professional before making trading decisions.',
  },
];

/**
 * A visible risk-disclosure block. Trading pages make bold performance claims,
 * so stating the downside plainly both improves trust and keeps the page honest.
 */
export default function RiskDisclosure() {
  return (
    <section className="py-14 md:py-20 bg-background-50 border-t border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-shell mx-auto">
          <Reveal>
            <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
              <div className="flex items-start gap-3.5">
                <span className="shrink-0 w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-800">
                  <i className="ri-shield-cross-line text-xl" aria-hidden="true"></i>
                </span>
                <div>
                  <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                    Risk Disclosure
                  </h2>
                  <p className="mt-1 text-sm text-foreground-600 max-w-2xl">
                    Please read this before acting on any figure on this page. Trading results are never
                    guaranteed, and the downside is just as real as the upside.
                  </p>
                </div>
              </div>

              <div className="mt-6 md:mt-7 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-5">
                {POINTS.map((point) => (
                  <div key={point.title} className="flex gap-3">
                    <i className={`${point.icon} mt-0.5 text-base text-accent-600`} aria-hidden="true"></i>
                    <div>
                      <h3 className="font-heading text-sm font-semibold text-foreground-950">
                        {point.title}
                      </h3>
                      <p className="mt-1 text-xs md:text-sm leading-relaxed text-foreground-600">
                        {point.body}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              <p className="mt-6 border-t border-background-200 pt-5 text-xs leading-relaxed text-foreground-500">
                Nothing on this page is a solicitation to trade. The GoldWarden EA is provided free of
                charge and you are solely responsible for how it is used on your own account. Decide
                whether trading gold is suitable for your circumstances and risk tolerance.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}